import gql from "graphql-tag";

import { TypedQuery } from "../../core/queries";
import { ProductsList } from "./gqlTypes/ProductsList";

export const homePageQuery = gql`
  query ProductsList {
    shop {
      description
      name
      homepageCollection {
        id
        backgroundImage {
          url
        }
        name
      }
    }
    categories(level: 0, first: 100) {
      edges {
        node {
          id
          name
          slug
          products(first: 20) {
            totalCount
            edges {
              node {
                id
                name
                slug
                thumbnail(size: 1024) {
                  alt
                  url
                }
              }
            }
          }
          backgroundImage {
            url
          }
        }
      }
    }
  }
`;

export const TypedHomePageQuery = TypedQuery<ProductsList, {}>(homePageQuery);
